import { ConfigProps } from '@config/types'

const config = ({ staticAssetPageUrl, staticPageUrlSuffix }: ConfigProps) => ({
  sportradarFixturesStaticPageUrl: `${staticAssetPageUrl}/sportradarFixtures${staticPageUrlSuffix}`,
  sportradarGeneralStatisticsStaticPageUrl: `${staticAssetPageUrl}/sportradarGeneralStatistics${staticPageUrlSuffix}`,
  sportradarLineupsStaticPageUrl: `${staticAssetPageUrl}/sportradarLineups${staticPageUrlSuffix}`,
  sportradarStaticPageUrl: `${staticAssetPageUrl}/sportradar${staticPageUrlSuffix}`,
})

export type configType = ReturnType<typeof config>
export default config
